export const SvgTags = ["svg", "circle", "path", "rect", "ellipse",
    "line", "polyline", "polygon", "g", "defs",
    "use", "symbol", "linearGradient", "radialGradient",
    "stop", "clipPath", "mask", "filter", "text",
    "tspan", "textPath", "image", "pattern", "marker",
    "animate", "animateTransform", "animateMotion",
    "feGaussianBlur", "feComposite", "feColorMatrix",
    "feMerge", "feMergeNode", "feOffset", "feFlood",
    "feBlend", "foreignObject"]